export class MapUtil {
    private static instance: MapUtil;

    static getInstance() {
        if (!MapUtil.instance) {
            MapUtil.instance = new MapUtil();
        }

        return MapUtil.instance;
    }

    /**
    * MapUtil is a singleton class, so use MapUtil.getInstance() method instead of creating new MapUtil().
    */
    private constructor() {

    }

    getMaxNumber(map: Map<number, any>): number {
        let maxNumber: number = 0;

        map.forEach((value: any, key: number) => {
            if (maxNumber < key)
                maxNumber = key;
        });

        return maxNumber;
    }
}